import React, { useState } from "react";
import "../assets/css/Certifications.css"; // Import du CSS
import { useTranslation } from "react-i18next";

// Importation des images
import cert1 from "../assets/img/certifications/AWS_CloudPractionner.png";
import cert2 from "../assets/img/certifications/AWS_SysOps.png";
import cert3 from "../assets/img/certifications/AWS_Archi_Assos.png";
import cert4 from "../assets/img/certifications/AWS_Archi_Pro.png";
import cert5 from "../assets/img/certifications/IMT-Atlantique.jpg";
import cert6 from "../assets/img/certifications/logo-mooc-gdp.png";
import cert7 from "../assets/img/certifications/MoocTotal.jpg";
import cert8 from "../assets/img/certifications/terraform.png";

// Liste des certifications avec descriptions
const certificationsList = [
  { title: "AWS Cloud Practitioner", description: "Certification de base pour AWS." },
  { title: "AWS SysOps", description: "Gestion des opérations et de l'administration AWS." },
  { title: "AWS Solution Architect - Associate", description: "Conception d'architectures cloud optimisées." },
  { title: "AWS Solution Architect - Professional", description: "Expertise avancée en architecture AWS." },
  { title: "IMT Atlantique", description: "Formation supérieure en ingénierie." },
  { title: "MOOC GDP", description: "Gestion de projet en ligne." },
  { title: "MOOC Total", description: "Formation sur l'énergie et le pétrole." },
  { title: "Terraform Certification", description: "Infrastructure as Code avec Terraform." },
];

const Certification = () => {
  const { t } = useTranslation();
  const [showList, setShowList] = useState(false); // État pour afficher/cacher la liste

  const handleClick = () => {
    setShowList(!showList); // Toggle de l'affichage
  };

  return (
    <>
    <div className="container section-title" data-aos="fade-up">
        <h2>Certification</h2>
        <h1 className="services-title">{t("CertificationAccroche")}</h1>
    </div>
    
    <div>
      <div className="animation-example" data-aos="fade-up">
        {/* Items normaux avec images */}
        <div className="item item-1">
          <div className="line"></div>
          <div className="dot"></div>
          <div className="circle"><img src={cert1} alt="Certification 1" className="cert-img cert-img-1" /></div>
        </div>
        <div className="item item-2">
          <div className="line"></div>
          <div className="dot"></div>
          <div className="circle"><img src={cert2} alt="Certification 2" className="cert-img cert-img-2" /></div>
        </div>
        <div className="item item-3">
          <div className="line"></div>
          <div className="dot"></div>
          <div className="circle"><img src={cert3} alt="Certification 3" className="cert-img cert-img-3" /></div>
        </div>
        <div className="item item-4">
          <div className="line"></div>
          <div className="dot"></div>
          <div className="circle"><img src={cert4} alt="Certification 4" className="cert-img cert-img-4" /></div>
        </div>

        {/* Items de type 2 avec images et "Coming..." */}
        <div className="item item-5 -type2">
          <div className="line"></div>
          <div className="dot"></div>
          <div className="circle"><img src={cert5} alt="Certification 5" className="cert-img cert-img-5" /></div>
        </div>
        <div className="item item-6 -type2">
          <div className="line"></div>
          <div className="dot"></div>
          <div className="circle"><img src={cert6} alt="Certification 6" className="cert-img cert-img-6" /></div>
        </div>
        <div className="item item-7 -type2">
          <div className="line"></div>
          <div className="dot"></div>
          <div className="circle"><img src={cert7} alt="Certification 7" className="cert-img cert-img-7" /></div>
        </div>
        <div className="item item-8 -type2">
          <div className="line"></div>
          <div className="dot"></div>
          <div className="circle"><img src={cert8} alt="Certification 8" className="cert-img cert-img-8" /></div>
        </div>
       
        {/* Centre - Ajout du onClick */}
        <div className="center" onClick={handleClick}>
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle certification-text">Certification</div>
        </div>
      </div>

      {/* Liste affichée en dehors de .animation-example */}
      {showList && (
        <div className="certification-list">
          <ul>
            {certificationsList.map((cert, index) => (
              <li key={index}>
                <strong>{cert.title}:</strong> {cert.description}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
    </>
  );
};

export default Certification;
